module.exports = __webpack_public_path__ + "media/src/images/app_icons/ios_splashscreens/ipadpro2_splash-4e8f67f6452a3481e4e066ced90ccf6b.png";